import { Pagination } from '@gaiads/telia-react-component-library';

// https://stackoverflow.com/a/56250826
export const onWheelDisable = (event: React.WheelEvent<HTMLInputElement>) => {
  const target = event.currentTarget;
  if (document.activeElement === target) {
    target.readOnly = true;
    setTimeout(() => (target.readOnly = false), 0);
  }
};

// Telia React component library docs mention "Pagination component is very simple and it relies heavily state/model outside of it."
// This function calculates all the values needed in the product pagination.
export function calculatePaginationValues(
  productsCount: number,
  currentPage: number,
  numberOfProductsPerPage: number,
  lastPageNumber: number,
): Partial<React.ComponentProps<typeof Pagination.PageSelector>> {
  // const lastPageNumber = Math.ceil(productsCount / numberOfProductsPerPage);

  const paginationValues: Partial<React.ComponentProps<typeof Pagination.PageSelector>> = {
    leftArrowPageNumber: currentPage > 1 ? currentPage - 1 : currentPage,
    rightArrowPageNumber: currentPage < lastPageNumber ? currentPage + 1 : currentPage,
    showLeftEllipsis: currentPage > 3,
    showRightEllipsis: lastPageNumber - currentPage > 2,
    currentPageAndAdjacentPages: [],
  };

  let currentPageAndAdjacentPages = [];

  // In case of only 1 page show that page as unclickable
  if (productsCount <= numberOfProductsPerPage) {
    currentPageAndAdjacentPages = [{ pageNumber: 1, clickable: false }];
  }
  // In case current page is first page show that as unclickable and next page after as clickable.
  // Show last page only if it's not the same as current page + 1 (otherwise last page number is shown twice).
  else if (currentPage === 1) {
    currentPageAndAdjacentPages = [
      { pageNumber: currentPage, clickable: false },
      { pageNumber: currentPage + 1, clickable: true },
    ];
    if (currentPage + 1 < lastPageNumber) paginationValues.lastPage = lastPageNumber;
  }
  // In case current page is last page show that as unclickable and the page before it as clickable.
  // Show first page only if it's not the same as current page - 1 (otherwise first page number is shown twice).
  else if (currentPage === lastPageNumber) {
    currentPageAndAdjacentPages = [
      { pageNumber: currentPage - 1, clickable: true },
      { pageNumber: currentPage, clickable: false },
    ];
    if (currentPage - 1 > 1) paginationValues.firstPage = 1;
  }
  // In case current page is not the first or last page, show both first and last page. For currentPageAndAdjacentPages show the
  // current page as unclickable and the page before and after it depending if they are the same as the first page and last page respectively.
  else {
    paginationValues.firstPage = 1;
    paginationValues.lastPage = lastPageNumber;
    if (currentPage - 1 !== paginationValues.firstPage) currentPageAndAdjacentPages.push({ pageNumber: currentPage - 1, clickable: true });
    currentPageAndAdjacentPages.push({ pageNumber: currentPage, clickable: false });
    if (currentPage + 1 !== lastPageNumber) currentPageAndAdjacentPages.push({ pageNumber: currentPage + 1, clickable: true });
  }

  paginationValues.currentPageAndAdjacentPages = currentPageAndAdjacentPages;

  return paginationValues;
}
